import { render, staticRenderFns } from "./MovimientosTablaActions.vue?vue&type=template&id=a5701c6e&scoped=true"
import script from "./MovimientosTablaActions.vue?vue&type=script&lang=js"
export * from "./MovimientosTablaActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5701c6e",
  null
  
)

export default component.exports